import { isNotEmpty, isNull } from 'rde-view-common/scripts/functions';
import StoreUtils from 'rde-view-common/scripts/storeUtils';

export const state = getInitialState();

export const mutations = {

  /**
   * ログインユーザ情報を設定します。
   *
   * @param state
   * @param loginUser
   */
  loginUser(state, loginUser) {
    state.loginUser.id = loginUser.id;
    state.loginUser.name = loginUser.name;
    state.loginUser.organizationName = loginUser.organizationName;
    state.loginUser.role = loginUser.role;
  },

  /**
   * ログインユーザ情報を設定します。
   *
   * @param state
   * @param programId
   */
  programId(state, programId) {
    state.programId = programId;
  },

  /**
   * メッセージを設定します。
   * 設定されたメッセージはMessageコンポーネントで表示されます。
   *
   * @param state
   * @param messages
   */
  messages(state, messages) {
    if (isNull(messages)) {
      state.messages = messages;
    } else {
      state.messages = messages.flat().filter((val) => isNotEmpty(val));
    }
  },

  /**
   * モーダルの表示状態を設定します。
   * true: 表示 false: 非表示
   *
   * @param state
   * @param modalOpened
   */
  modalOpened(state, modalOpened) {
    state.modalOpened = modalOpened;
  },

  /**
   * 処理中かどうかを設定します。
   * 画面ロックに使用します。
   *
   * @param state
   * @param inProcess
   */
  inProcess(state, inProcess) {
    state.inProcess = inProcess;
  },

  /**
   * システムエラーのオブジェクトを設定します。
   *
   * @param state
   * @param systemErrorObj {{message: String, status: any}}
   */
  systemErrorObj(state, systemErrorObj) {
    state.systemErrorObj = systemErrorObj;
  },

  /**
   * 検索・ソート・ページネーション条件を設定します。
   *
   * @param state
   * @param obj
   */
  searchState(state, obj) {
    state.searchState = obj;
  },

  /**
   * フォームの内容を保持します。
   *
   * @param state
   * @param obj {{key: String, formObj: {}}}
   */
  storeForm(state, obj) {
    if (isNull(state.searchState[obj.key])) state.searchState[obj.key] = {};
    state.searchState[obj.key].formObj = obj.formObj;
  },

  /**
   * 指定されたkeyのフォーム内容をクリアします。
   *
   * @param state
   * @param key
   */
  clearForm(state, key) {
    if (isNull(state.searchState[key])) return;
    delete state.searchState[key].formObj;
  },

  /**
   * ソート条件を保持します。
   *
   * @param state
   * @param obj {{key: String, sortProps: {sortKey: String, isDesc: Boolean}}}
   */
  storeSortProps(state, obj) {
    if (isNull(state.searchState[obj.key])) state.searchState[obj.key] = {};
    state.searchState[obj.key].sortProps = obj.sortProps;
  },

  /**
   * 指定されたkeyのソート条件をクリアします。
   *
   * @param state
   * @param key
   */
  clearSortProps(state, key) {
    if (isNull(state.searchState[key])) return;
    delete state.searchState[key].sortProps;
  },

  /**
   * ページネーションの条件を保持します。
   *
   * @param state
   * @param obj {{key: String, paginationState: {limit: Number, offset: Number}}}
   */
  storePaginationState(state, obj) {
    if (isNull(state.searchState[obj.key])) state.searchState[obj.key] = {};
    state.searchState[obj.key].paginationState = obj.paginationState;
  },

  /**
   * 指定されたkeyのページネーションの条件をクリアします。
   *
   * @param state
   * @param key
   */
  clearPaginationState(state, key) {
    if (isNull(state.searchState[key])) return;
    delete state.searchState[key].paginationState;
  },

  /**
   * 検索に関わる全ての条件をクリアします。
   *
   * @param state
   * @param key
   */
  clearAllSearchState(state, key) {
    delete state.searchState[key];
  },

  /**
   * すべてのstateを初期値に戻します。
   *
   * @param state
   */
  clearAll(state) {
    const initialState = getInitialState();
    const keys = Object.keys(initialState);
    Object.assign(state, initialState);
    Object.keys(state)
      .filter(key => !keys.includes(key))
      .forEach(key => StoreUtils.clearAll(key));
  }
};

function getInitialState() {
  return {
    loginUser: {
      id: null,
      name: null,
      organizationName: null,
      role: {}
    },
    programId: null,
    messages: [],
    modalOpened: false,
    inProcess: false,
    systemErrorObj: {},
    searchState: {}
  };
}
